module.exports = __webpack_public_path__ + "slider1.jpg?ac32345770cfa02e02522cd01cd3c5bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/slider1.jpg
// module id = 121
// module chunks = 0